<template>
  <div class="footer" v-if="!isDisable">
    <div class="d-flex justify-space-between" style="max-width: 1800px; margin: 0 auto;">
      <div>© MyKet All Rights Reserved.</div>
      <div>
        <a class="white--text" href="https://docs.myket.in.th" target="_blank"><b>คู่มือใช้งานระบบ</b></a> | เวอร์ชั่น {{
          getVersion }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      areaViewType: state => state.markets.areaViewType,
    }),
    getVersion() {
      const packageJson = require("../../package.json");
      return packageJson.version;
    },
    isDisable() {
      if (this.$route.params.projectId && this.$route.params.marketId) {
        let projectId = this.$route.params.projectId;
        let marketId = this.$route.params.marketId;
        let dashPath = `/project/${projectId}/market/${marketId}/view`;
        let settingPath = `/project/${projectId}/market/${marketId}/setting/area`;
        if (this.$route.path == dashPath && (this.areaViewType == 'plan' || this.areaViewType == 'calendar')) {
          return true;
        } else if (this.$route.path == settingPath) {
          return true;
        }
      } else if (this.$route.params.projectId) {
        let projectId = this.$route.params.projectId;
        let disablePath = `/project/${projectId}/plan`;
        let settingPath = `/project/${projectId}/settings/settingplan`;
        if (this.$route.path == disablePath || this.$route.path == settingPath) {
          return true;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background-color: var(--v-footer-base);
  color: white;
  font-weight: 300;
  font-size: 15px;
  padding: 17px 20px;
}
.bedrock{
  background-color: var(--v-bedrock-base);
}
</style>
